import { CloudUploadOutlined } from '@ant-design/icons'
import type { UploadProps } from 'antd'
import { Upload } from 'antd'
import { RcFile } from 'antd/es/upload'
import { I18nContext } from 'contexts/I18n/I18nProvider'
import React, { useContext } from 'react'
import '../index.scss'

type UploadComponentProps = {
  setFile: React.Dispatch<React.SetStateAction<RcFile | undefined>>
  onFileValidation?: (file: RcFile) => void
  onFailedFileValidation?: () => void
  props: UploadProps
  subtitle?: string
  icon?: React.ReactNode
}

const { Dragger } = Upload;

export default function UploadComponent({
  setFile,
  onFileValidation,
  onFailedFileValidation,
  props,
  subtitle = "",
  icon = <CloudUploadOutlined />
}: UploadComponentProps) {
  const t = useContext(I18nContext)

  const beforeFileUpload = async (file: RcFile) => {
    setFile(file)
    if (onFileValidation) {
      try {
        await  onFileValidation(file)
      } catch {
          if (onFailedFileValidation) {
            onFailedFileValidation()
        }
      }
    }
    return false
  }

  return (
    <Dragger {...props} beforeUpload={(file) => beforeFileUpload(file)}>
      <p className="ant-upload-drag-icon">
        {icon}
      </p>
      <p className="ant-upload-text">{t('upload.click_or_drag')}</p>
      <p>{subtitle}</p>
    </Dragger>
  )
}
